const beginNumber = 2500288.00;
const elapsedTime = ((new Date().getTime() / 1000) - (new Date('2022-08-24').getTime() / 1000)).toFixed(0);

export const currentNumber = beginNumber + (elapsedTime / 100);
